import { ThemeProvider } from "components";
import { Outlet } from "react-router-dom";
import { paletteDarkTheme } from "utils/ColorTheme";
import { ThemeContainer } from "utils/Theme";
import useDocumentTitle from "utils/useDocumentTitle";
import Footer from "./Components/Footer";
import Navbar from "./Components/Navbar";

const Website = () => {
  useDocumentTitle("Explorer");
  const { theme } = ThemeContainer();

  return (
    <ThemeProvider theme={{ ...theme, palette: paletteDarkTheme?.palette }}>
      <Navbar />
      <Outlet />
      <Footer />
    </ThemeProvider>
  );
};

export default Website;
